import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  subscriptionForEdit: {
    id: undefined,
    name: "",
    title: "",
    sellerFee: "",
    feature: "",
    description: "",
    price: "",
    iconUrl: "",
    assetFeaturedPricing: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  subscriptionId: undefined,
  showsubscriptionPopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    subscriptionListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    subscriptionList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadsubscriptionForEdit: (state, action) => {
      const payload = action.payload;

      state.subscriptionForEdit.name = payload.name;
      state.subscriptionForEdit.id = payload.id;
      state.subscriptionForEdit.title = payload.title;
      state.subscriptionForEdit.sellerFee = payload.sellerFee;
      state.subscriptionForEdit.feature = payload.feature;
      state.subscriptionForEdit.description = payload.description;
      state.subscriptionForEdit.price = payload.price;
      state.subscriptionForEdit.iconUrl = payload.iconUrl;
      state.subscriptionForEdit.assetFeaturedPricing =
        payload.assetFeaturedPricing;
    },
    loadSubscriptionMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    openSubscriptionApprove: (state, action) => {
      const { subscriptionId } = action.payload;

      state.subscriptionId = subscriptionId;
      state.showSubscriptionPopover = !state.showSubscriptionPopover;
    },
    setDeleteDialogData: (state, action) => {
      const { subscriptionId } = action.payload;

      state.showDeleteDialog = !state.showDeleteDialog;
      state.subscriptionId = subscriptionId;
    },
  },
});
